import { frontendURL } from 'dashboard/helper/URLHelper';

import CardsIndex from './CardsIndex.vue';

const meta = { permissions: ['administrator', 'agent', 'custom_role'] };

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/cards'),
      name: 'cards_index',
      meta,
      component: CardsIndex,
    },
    {
      path: frontendURL('accounts/:accountId/cards/board/:pipelineId(\\d+)'),
      name: 'cards_pipeline_index',
      meta,
      component: CardsIndex,
    },
  ],
};
